export default "__VITE_ASSET__CDDafGZe__"